function countdown() {
    const now = new Date();

    // Set the target time (2 days, 14 hours, 35 minutes, and 60 seconds from now)
    const countdownDuration = 2 * 24 * 60 * 60 * 1000 + // 2 days in milliseconds
                              14 * 60 * 60 * 1000 +     // 14 hours in milliseconds
                              35 * 60 * 1000 +          // 35 minutes in milliseconds
                              60 * 1000;                // 60 seconds in milliseconds

    const endTime = new Date(now.getTime() + countdownDuration); // Set end time based on duration

    function updateCountdown() {
        const currentTime = new Date();
        const timeLeft = endTime - currentTime;

        if (timeLeft <= 0) {
            document.querySelector('.timer').innerHTML = "Time's up!";
            clearInterval(timerInterval); // Stop the timer when time is up
            return;
        }

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        // Function to add leading zeros
        function addLeadingZero(num) {
            return num < 10 ? '0' + num : num;
        }
        if(document.getElementById("days") != null) {
          document.getElementById("days").textContent = addLeadingZero(days);
        }
        if(document.getElementById("hours") != null) {
          document.getElementById("hours").textContent = addLeadingZero(hours);
        }
        if(document.getElementById("minutes") != null) {
          document.getElementById("minutes").textContent = addLeadingZero(minutes);
        }
        if(document.getElementById("seconds") != null) {
          document.getElementById("seconds").textContent = addLeadingZero(seconds);
        }
    }

    const timerInterval = setInterval(updateCountdown, 1000);
}

countdown(); // Initialize the countdown
